module.exports = __webpack_public_path__ + "img/top_30.05713a31.png";